export const VAULTS_PER_PAGE = 5000
export const MIN_TVL = 100_000
export const HISTORICAL_POINTS_PER_PAGE = 20_000
export const MAX_APY = 10 // 1000%
